import { Select, SelectProps } from 'antd';
import { ChevronDown } from 'lucide-react';
import React, { ReactNode } from 'react';
import { styled } from 'styled-components';
import { twMerge } from 'tailwind-merge';

import { If } from '@components/condition';

const SelectStyle = styled(Select)<{ colorDisable?: string; height?: number }>`
  .ant-select-selector {
    ${({ height }) => `height: ${height}px !important;`}
    display: flex !important;
    align-items: center !important;
  }
  .ant-select-selector {
    ${({ colorDisable }) => `color: ${colorDisable} !important`};
  }
  .ant-select-selection-item {
    height: 100% !important;
    font-size: 14px;
  }
  .ant-select-selection-item,
  .ant-select-selection-search-input {
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-placeholder {
    font-size: 14px;
  }
`;

export interface BaseSelectProps {
  className?: string;
  classNameInput?: string;
  error?: string;
  required?: boolean;
  title?: ReactNode;
  name?: string;
  prefixIcon?: ReactNode;
  classNameTitle?: string;
  disabled?: boolean;
  suffixIcon?: ReactNode;
  colorDisable?: string;
  height?: number;
  filterOption?;
}

export const BaseSelect: React.FC<BaseSelectProps & SelectProps> = ({
  className,
  classNameInput = '',
  error,
  required = false,
  title,
  name,
  classNameTitle = '',
  size = 'large',
  prefixIcon = null,
  colorDisable = '#4D5461',
  height = 48,
  disabled = false,
  ...props
}) => {
  return (
    <div className={className} id="base-selector">
      <If
        condition={title}
        Then={
          <label
            htmlFor={name}
            className={`text-secondary_500 text-sm mb-2 flex items-center gap-1 ${classNameTitle}`}
          >
            {title} {required && <span className="text-error">*</span>} {prefixIcon}
          </label>
        }
      />
      <SelectStyle
        virtual={false}
        suffixIcon={<ChevronDown />}
        className={twMerge('w-full', classNameInput)}
        size={size}
        style={{ color: '#34306A' }}
        status={error ? 'error' : ''}
        colorDisable={disabled && colorDisable}
        height={height}
        disabled={disabled}
        getPopupContainer={() => document.getElementById('base-selector')}
        placement={props?.placement ?? 'bottomRight'}
        {...props}
      />
      {error && <span className="text-error text-[12px] md:text-sm">{error}</span>}
    </div>
  );
};
